import { icons, translations } from "../../Helpers/WindowHelpers";
import parse from 'html-react-parser';
interface MobileStepDisplayInterface {
    children?: React.ReactNode;
    classes?: string,
    open?: boolean;
    setOpen?: (open: boolean) => void;
}

const MobileStepDisplay = ({ children, classes, open, setOpen }: MobileStepDisplayInterface) => {
    if (!open) {
        document.body.classList.remove('modal-open');
    } else {
        document.body.classList.add('modal-open');
    }
    return (<>
        <button
            type="button"
            className={`mobile-configurator-menu-trigger ${classes || ''}`}
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            aria-controls="configurator-mobile-menu"
            aria-label="View Mobile Menu">
            <span className="visually-hidden">{translations.open_menu}</span>
            <span>{parse(icons.dots ?? '')}</span>
        </button>
        <div id="configurator-mobile-menu" className={`configurator-mobile-menu-modal is-mobile ${open ? 'is-open' : ''}`}>
            <div className="configurator-mobile-menu-modal__inner">
                <div
                    className="configurator-mobile-menu-modal__close"
                    onClick={() => setOpen(false)}
                    aria-label="Close Configurator Menu"
                    role="button"
                    tabIndex={0}>
                    <span className="visually-hidden">{translations.close_menu}</span>
                    <span>{parse(icons.close ?? '')}</span>
                </div>
                {children}
            </div>
        </div>
    </>);
}

export default MobileStepDisplay;